var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('nav',[_c('NavBar')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }